import { defineMessages } from "react-intl";

const DataTableMessages = defineMessages({
  copied: {
    defaultMessage: "Copied!",
    id: "datatable.copied",
  },
  copyToClipboard: {
    defaultMessage: "Copy to clipboard",
    id: "datatable.copy.clipboard",
  },
  of: {
    defaultMessage: "of",
    id: "datatable.paginator.of",
  },
  to: {
    defaultMessage: "to",
    id: "datatable.paginator.to",
  },
});

export default DataTableMessages;
